import React from "react";
import * as dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import { AlertsProvider, PageContextProvider, NotificationsProvider } from "./src/context";
import { RCLProvider } from "./src/components/RCL";
import { SecurityProvider } from "./src/templates/user-account/context/SecurityProvider";
import "./src/styles/index.scss";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
	const lang = props?.pageContext?.locale?.substring(0, 2)?.toLowerCase() || "en";
	dayjs.locale(lang === "fr" ? "fr" : "en");

	return (
		<SecurityProvider lang={props?.pageContext?.locale}>
			<PageContextProvider data={{ ...props?.pageContext, lang }}>
				<AlertsProvider lang={props?.pageContext?.locale} timestamp={props?.pageContext?.timestamp}>
					<RCLProvider lang={props?.pageContext?.locale}>
						<NotificationsProvider locale={props?.pageContext?.locale}>
							{element}
						</NotificationsProvider>
					</RCLProvider>
				</AlertsProvider>
			</PageContextProvider>
		</SecurityProvider>
	);
};

// Called every time the route changes (including first load)
export const onRouteUpdate = ({ location, prevLocation }) => {
	if (window?.analytics && prevLocation && prevLocation.pathname !== location.pathname) {
		setTimeout(() => {
			// Trigger Segment page tracking
			window.analytics.page({ brand_code: process.env.GATSBY_SEGMENT_BRAND_CODE });
		}, 10);
	}
};
